module.exports = __webpack_public_path__ + "static/media/Alba soffa U-soffa FS 210_3 OEBR tyg genesis Dove 3 miljö modell 2024.dbc7b6c1.jpg";